import React from 'react';
import PageTemplate from '../../components/Common/PageTemplate';
import { FileText, Calendar, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const FacultyBoardDecisions = () => {
  const { t } = useTranslation();

  const years = [
    { year: '2025', count: 4, description: `2025 ${t('faculty_board_decisions.year_label')}` },
    { year: '2024', count: 5, description: `2024 ${t('faculty_board_decisions.year_label')}` },
    { year: '2023', count: 10, description: `2023 ${t('faculty_board_decisions.year_label')}` },
    { year: '2022', count: 1, description: `2022 ${t('faculty_board_decisions.year_label')}` }
  ];

  return (
    <PageTemplate
      title={t('faculty_board_decisions.title')}
      breadcrumb={[
        { label: t('faculty_board_decisions.breadcrumb.home'), url: '/' },
        { label: t('faculty_board_decisions.breadcrumb.decisions'), url: '/kararlar' },
        { label: t('faculty_board_decisions.breadcrumb.current') }
      ]}
    >
      <div className="max-w-4xl mx-auto">
        {/* Giriş */}
        <div className="bg-gradient-to-br from-blue-50 to-indigo-100 rounded-xl p-8 mb-8">
          <div className="flex items-center mb-4">
            <FileText className="w-8 h-8 text-blue-600 mr-3" />
            <h2 className="text-2xl font-bold text-gray-800">{t('faculty_board_decisions.intro.title')}</h2>
          </div>
          <p className="text-gray-700 leading-relaxed">
            {t('faculty_board_decisions.intro.description')}
          </p>
        </div>

        {/* Yıllar */}
        <div className="grid gap-6">
          {years.map((yearData) => (
            <div
              key={yearData.year}
              className="bg-white rounded-xl shadow-lg border border-gray-200 hover:shadow-xl transition-all duration-300 group"
            >
              <Link
                to={`/kararlar/fakulte-kurulu/${yearData.year}`}
                className="block p-6"
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-4">
                    <div className="bg-blue-100 rounded-lg p-3 group-hover:bg-blue-200 transition-colors">
                      <Calendar className="w-6 h-6 text-blue-600" />
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-800 mb-1">
                        {yearData.description}
                      </h3>
                      <div className="flex items-center mt-2 text-sm text-blue-600">
                        <FileText className="w-4 h-4 mr-1" />
                        <span>{yearData.count} {t('faculty_board_decisions.decision_count')}</span>
                      </div>
                    </div>
                  </div>
                  <div className="text-blue-600 group-hover:text-blue-700 group-hover:translate-x-1 transition-all">
                    <ArrowRight className="w-5 h-5" />
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>

        {/* Alt Bilgi */}
        <div className="mt-8 p-6 bg-gray-50 rounded-xl">
          <div className="flex items-start space-x-3">
            <div className="bg-yellow-100 rounded-full p-2 mt-1">
              <FileText className="w-5 h-5 text-yellow-600" />
            </div>
            <div>
              <h4 className="font-semibold text-gray-800 mb-2">{t('faculty_board_decisions.info.title')}</h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                {t('faculty_board_decisions.info.description')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </PageTemplate>
  );
};

export default FacultyBoardDecisions;
